import { formatCurrency } from '@crm/shared';
import { cn } from '@crm/ui';
import { MessageSquare } from 'lucide-react';
import type { MessagePack } from '../api';

interface MessagePacksProps {
  packs: MessagePack[];
  escolhido: number;
  onPick: (messages: number) => void;
  /** O que ja vai na mesma cobranca, como a mensalidade da linha. */
  base?: number;
  baseLabel?: string;
  emptyLabel?: string;
}

export function MessagePacks({
  packs,
  escolhido,
  onPick,
  base = 0,
  baseLabel,
  emptyLabel,
}: MessagePacksProps) {
  return (
    <ul className="grid gap-2 sm:grid-cols-2">
      {packs.map((pack) => {
        const mensagens = `${pack.messages.toLocaleString('pt-BR')} mensagens`;

        return (
          <li key={pack.messages}>
            <button
              type="button"
              onClick={() => onPick(pack.messages)}
              className={cn(
                'flex w-full items-center gap-2.5 rounded-lg border px-3 py-2.5 text-left transition-colors',
                pack.messages === escolhido
                  ? 'border-primary bg-primary/10'
                  : 'border-border hover:bg-muted/60',
              )}
            >
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                <MessageSquare className="h-4 w-4" />
              </span>

              <span className="min-w-0 flex-1 truncate text-sm font-medium">
                {pack.messages === 0
                  ? (emptyLabel ?? mensagens)
                  : baseLabel
                    ? `${baseLabel} + ${mensagens}`
                    : mensagens}
              </span>

              <span className="shrink-0 text-right">
                <span className="block text-sm font-medium">
                  {formatCurrency(base + pack.price)}
                </span>
                {base > 0 ? (
                  <span className="block text-[11px] text-muted-foreground">por mes</span>
                ) : null}
              </span>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
